import { loadGA, loadGoogleMap } from "loadScript";

import("./bootstrap");

loadGA();
loadGoogleMap();
